import React, {Suspense} from 'react';

const SalaryPaymentAndSheetComponent = React.lazy(() => import('../Component/SalaryPaymentAndSheetComponent/SalaryPaymentAndSheetComponent'));

function SalarySheetPage(props) {
    return (
        <>
            <Suspense fallback={<div>Loading...</div>}>
                <SalaryPaymentAndSheetComponent/>
            </Suspense>
        </>
    );
}

export default SalarySheetPage;